import React, { useRef } from "react";
import { Typography, useTheme } from "@mui/material";
import "react-medium-image-zoom/dist/styles.css";
import "../JaldiLab.css";
import DesignImg1 from "../../../assets/Images/DesignPrincipals/image_design1.png";
import DesignImg2 from "../../../assets/Images/readPrinciples.jpg";
import DesignImg3 from "../../../assets/Images/DesignPrincipals/image_design3.png";
import DesignImg4 from "../../../assets/Images/figure15.png";
import DesignImg5 from "../../../assets/Images/DesignPrincipals/image design5.png";
import DesignImg6 from "../../../assets/Images/DesignPrincipals/image design6.png";
import DesignImg7 from "../../../assets/Images/DesignPrincipals/image design7.png";
import DesignImg8 from "../../../assets/Images/DesignPrincipals/image design8.png";
import DesignImg9 from "../../../assets/Images/DesignPrincipals/image design9.png";
import DesignImg10 from "../../../assets/Images/DesignPrincipals/image design10.png";
import DesignImg11 from "../../../assets/Images/DesignPrincipals/Image design11.png";
import DesignImg12 from "../../../assets/Images/DesignPrincipals/image design 12.png";
import DesignImg13 from "../../../assets/Images/DesignPrincipals/ID13.png";
import DesignImg14 from "../../../assets/Images/DesignPrincipals/ID14.webp";
import DesignImg15 from "../../../assets/Images/DesignPrincipals/ID15.webp";
import ID16 from "../../../assets/Images/DesignPrincipals/ID16.jpg";
import ID17 from "../../../assets/Images/DesignPrincipals/ID17.png";
import ID19 from "../../../assets/Images/DesignPrincipals/ID19.jpg";
import ID18 from "../../../assets/Images/DesignPrincipals/image design18.png";
import ID20 from "../../../assets/Images/DesignPrincipals/ID20.png";
import ID21 from "../../../assets/Images/DesignPrincipals/ID21.png";
import ID22 from "../../../assets/Images/DesignPrincipals/ID22.png";
import ID23 from "../../../assets/Images/DesignPrincipals/ID23.png";
import ID24 from "../../../assets/Images/DesignPrincipals/ID24.webp";
import ID25 from "../../../assets/Images/DesignPrincipals/ID25.png";
import ID26 from "../../../assets/Images/DesignPrincipals/e-sewa kendra_IMG_1955.png";
import ID28 from "../../../assets/Images/DesignPrincipals/ID28.jpg";
import ID29 from "../../../assets/Images/DesignPrincipals/ID29.png";
import ID30 from "../../../assets/Images/DesignPrincipals/ID30.jpg";
import ID31 from "../../../assets/Images/DesignPrincipals/ID31.png";
import ID32 from "../../../assets/Images/DesignPrincipals/ID32.webp";
import ID33 from "../../../assets/Images/DesignPrincipals/ID33.jpg";
import ID34 from "../../../assets/Images/DesignPrincipals/ID34.jpg";
import ID35 from "../../../assets/Images/DesignPrincipals/ID35.jpg";
import ID36 from "../../../assets/Images/DesignPrincipals/ID36.png";
import UnitedState from "../../../assets/Images/United_state.png";
import storageSystem2 from "../../../assets/Images/DesignPrincipals/designPrinciple2.jpg";

import Divider from "@mui/material/Divider";
import {
  generateOrderedList,
  referenceHtml,
  referenceTootKit,
  h1style,
  h2style,
  h3style,
  h4style,
  sectionStyle,
  referenceStyle,
  paraStyle,
} from "./ChapterList";
import { DashedBorderStyle } from "./ChapterList";
import ImageWithCaption from "../../../components/ChapterImage/ImageWithCaption";
import CustomImageCaption from "../../../components/ChapterImage/CustomImageCaption";
import CaptionWithBorders1 from "../../../components/ChapterImage/Image";
import hgIndia from "../../../assets/Images/HGIndia.jpg";
import emergencyExit1 from "../../../assets/Images/DesignPrincipals/emergencyExit1.jpg";
import emergencyExit2 from "../../../assets/Images/DesignPrincipals/emergencyExit2.jpg";
import storageSystem1 from "../../../assets/Images/DesignPrincipals/storageSystem1.jpg";
import {
  ImageDesc2, ImageDesc3, ImageDesc4, ImageDesc5, ImageDesc6, ImageDesc7, ImageDesc8,
  ImageDesc9, ImageDesc10, ImageDesc11, ImageDesc12, ImageDesc13, ImageDesc14, ImageDesc15,
  ImageDesc16, ImageDesc17, ImageDesc18, ImageDesc19, ImageDesc20, ImageDesc21, ImageDesc22,
  ImageDesc23, ImageDesc24, ImageDesc25, ImageDesc26, ImageDesc27, ImageDesc28, FigureDesc12,
  FigureDesc13, FigureDesc14, FigureDesc15, FigureDesc16, FigureDesc17, FigureDesc18, FigureDesc19
}
  from "../../../utils/tmp/ImageDescription/DesignPrincipleID";
import useCustomLogic from "../../../Hooks/UseCustomLogic";

const DesignPrincipals = ({ goToSection }) => {
  const theme = useTheme();
  const { isXs, isSm } = useCustomLogic();

  const pointStyle = {
    fontFamily: "Lato",
    fontSize: "18px",
    fontWeight: "400",
    lineHeight: "27px",
    color: "#555555",
    letterSpacing: "0em",
    textAlign: "justified",
    margin: "5px 0px",
  };

  const referencesRef = useRef(null);

  const handleScrollToReferences = () => {
    if (referencesRef.current) {
      referencesRef.current.scrollIntoView({
        block: "center",
        inline: "nearest",
        behavior: "smooth",
      });
    }
  };
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        block: "center",
        inline: "nearest",
        behavior: "smooth",
      });
    }
  };
  const reference = (_data, number) => {
    return referenceTootKit(_data, number, handleScrollToReferences);
  };

  const generateCustomOrderedListObj = (_stringsArray, type) => {
    return (
      <Typography>
        <ol type={type}>
          {_stringsArray.map((arr, index) => (
            <>
              <li style={{ ...pointStyle, paddingLeft: "10px" }} key={index}>
                {arr.content}
                {arr.img}
                {arr.para}
              </li>
            </>
          ))}
        </ol>
      </Typography>
    );
  };
  const generateCustomOrderedList = (_stringsArray, type) => {
    return (
      <Typography>
        <ol type={type}>
          {_stringsArray.map((text, index) => (
            <li style={{ ...pointStyle, paddingLeft: "10px" }} key={index}>
              {text}
            </li>
          ))}
        </ol>
      </Typography>
    );
  };

  const referenceData = [
    {
      content: "Harmonised Guidelines 2021, p. 23.",
    },
    {
      content: (
        <>
          Lucy Wang, ‘Delhi High Court’s new expansion taps into green building
          principles' (<i>Inhabit,</i> 11 January 2018)
        </>
      ),
      link: "https://inhabitat.com/delhi-high-Courts-new-expansion-taps-into-green-building-principles/new-Courts-complex-by-design-forum-international-4/",
      description:
        "<https://inhabitat.com/delhi-high-Courts-new-expansion-taps-into-green-building-principles/new-Courts-complex-by-design-forum-international-4/>",
    },
    {
      content: "'Warangal POCSO & Family Court’ (WeDesignLocal, 2021)",
      link: "https://www.wedesignlocal.com/warangal",
      description:
        " <https://www.wedesignlocal.com/warangal> [“Warangal District Court Design”]",
    },
    {
      content:
        "Harmonised Guidelines 2021, p. 26, Table 2.1: Understanding Disability & Diversity.",
    },
    {
      content: "Warangal District Court Design (2021).",
    },
    {
      content: (
        <>
          Warangal District Court,{" "}
          <i>
            The Court and the Courtyard: Our Journey of Transforming Warangal
            Court
          </i>{" "}
          (2022). [“Warangal Transformation Report”]
        </>
      ),
    },
    {
      content: (
        <>
          ‘Fresh Restaurant Crisis Management Plan Template’ (
          <i>Riteforyouwellness</i>)
        </>
      ),
      link: "https://riteforyouwellness.com/fresh-restaurant-crisis-management-plan-template/fresh-restaurant-crisis-management-plan-template-2/",
      description:
        "<https://riteforyouwellness.com/fresh-restaurant-crisis-management-plan-template/fresh-restaurant-crisis-management-plan-template-2/> ",
    },
    {
      content: (
        <>
          Jessie Darland, ‘Kitsap County Courthouse construction could begin in
          2020’ (<i>Kitsap Sun,</i> 23 January 2020)
        </>
      ),
      link: "https://www.kitsapsun.com/story/news/2020/01/23/kitsap-county-Courthouse-construction-could-begin-2020/4558427002/",
      description:
        " <https://www.kitsapsun.com/story/news/2020/01/23/kitsap-county-Courthouse-construction-could-begin-2020/4558427002/>",
    },
    {
      content: (
        <>
          ‘Under-Construction Court Buildings’ (<i>Karnataka Judiciary</i>)
        </>
      ),
      link: "https://karnatakajudiciary.kar.nic.in/iandm/courtbuilding.php",
      description:
        " <https://karnatakajudiciary.kar.nic.in/iandm/courtbuilding.php>",
    },
    {
      content: "High Court of Karnataka, ‘E-Seva Kendra’ ",
      link: "https://karnatakajudiciary.kar.nic.in/eseva.php",
      description:
        "<https://karnatakajudiciary.kar.nic.in/eseva.php>  [“Karnataka E-Seva Kendra”] ",
    },
    {
      content: (
        <>
          ‘United States Federal Courthouse’ (<i>PWP Landscape Architecture</i>){" "}
        </>
      ),
      link: "https://www.pwpla.com/projects/seattle-federal-court",
      description: "https://www.pwpla.com/projects/seattle-federal-court",
    },
    {
      content: (
        <>
          Keith Fentress, ‘User-Friendliness as an Emerging Courthouse Design
          Trend’ (<i>Fentress Incorporated,</i> 2018){" "}
        </>
      ),
      link: "https://blog.fentress.com/blog/user-friendliness-as-an-emerging-courthouse-design-trend",
      description:
        " <https://blog.fentress.com/blog/user-friendliness-as-an-emerging-courthouse-design-trend>",
    },
    {
      content: (
        <>
          Nolan Lewis, ‘Justice gets a high-tech makeover at Delhi High Court’ (
          <i>Architectural Digest India,</i> 12 October 2018){" "}
        </>
      ),
      link: "https://www.architecturaldigest.in/content/delhi-high-court-extension-design-forum-international/",
      description:
        "<https://www.architecturaldigest.in/content/delhi-high-Court-extension-design-forum-international/> [“Delhi High Court Extension Design”]",
    },
    {
      content:
        "Harmonised Guidelines 2021, p. 286: Image 5.24: Priority seating signs.",
    },
    {
      content: (
        <>
          ‘Project References’ <i>(Messung Building Automation & Controls)</i>{" "}
        </>
      ),
      link: "https://www.messungbacd.com/images/projects/Hubli-Court-Complex.jpg",
      description:
        " <https://www.messungbacd.com/images/projects/Hubli-Court-Complex.jpg>",
    },
    {
      content: "ECBC (2017)",
    },
    {
      content: (
        <>
          Rahul Kadri, ‘National Judicial Academy, at Bhopal, by IMK Architects’
          (<i>ArchitectureLive!,</i> 13 May 2021){" "}
        </>
      ),
      link: "https://architecture.live/national-judicial-academy-bhopal-imk-architects/",
      description:
        " <https://architecture.live/national-judicial-academy-bhopal-imk-architects/> [“National Judicial Academy Design”]",
    },
    {
      content: "Warangal District Court Design.",
    },
    {
      content: "Delhi High Court Extension Design.",
    },
    {
      content: (
        <>
          ‘Krushi Bhawan / Studio Lotus’ (<i>ArchDaily,</i> 2018)
        </>
      ),
      link: "https://www.archdaily.com/941738/krushi-bhawan-studio-lotus",
      description:
        " <https://www.archdaily.com/941738/krushi-bhawan-studio-lotus>",
    },
    {
      content: "National Judicial Academy Design.",
    },
    {
      content: "‘Indira Paryavaran Bhawan’ (NZEB) ",
      link: "https://nzeb.in/case-studies/nzebs-in-india/nzebs-in-india-case-studies-list/ipb-case-study/",
      description:
        " <https://nzeb.in/case-studies/nzebs-in-india/nzebs-in-india-case-studies-list/ipb-case-study/>",
    },
    {
      content: (
        <>
          Madan, ‘India’s first solar-powered Court Complex in Khunti, Jharkhand
          inaugurated by Modi’ (<i>Planet Custodian,</i> 3 October 2015){" "}
        </>
      ),
      link: "https://www.planetcustodian.com/indias-first-solar-powered-Court-complex-in-khunti-jharkhand-inaugurated-by-modi/7883/",
      description:
        " <https://www.planetcustodian.com/indias-first-solar-powered-Court-complex-in-khunti-jharkhand-inaugurated-by-modi/7883/>",
    },
  ];

  const guideLine2Array = [
    {
      content:
        "Designing an intuitive information and wayfinding system using maps, floor plans, and directional signs for easy orientation and navigation for all users of the Court Complex. It involves ensuring that the information and wayfinding system is well-integrated with the Court building architecture and interior design, to deliver the best possible experience for the users.",
    },
    {
      content:
        "Using clear and concise signage with universally understood icons, Braille, local and regional languages, adequate lighting, and digital displays for information dissemination. This involves ensuring legible user-friendly signage with adequate font size, colour and type, and communication of important information via two senses or more, ie., tactile, audible and visual.",
      img: (
        <ImageWithCaption
          imageSrc={[DesignImg7]}
          captionText={
            <>
              <b>For example, </b>use of bilingual signage with colourful icons
              would create an easily navigable space for the local users, as in
              the case of the signage used in the POCSO and Family Court in
              Warangal.{reference(referenceData[2], 3)}
            </>
          }
          caption="Image 4: Accessible signage at the POCSO and Family Courts in Warangal District Court, Telangana"
          creditLabel="Source"
          creditValue="Warangal District Court Design"
          isZoom={true}
          // zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc4}
        />
      ),
    },
  ];
  const guideLine3Array = [
    {
      content: (
        <>
          Acknowledging the diversity of all users of the Court Complex to bring
          an inclusive approach in the processes of the Court. This involves
          addressing the accessibility needs of people of all ages, gender,
          ability, sizes, caste, class and religion,
          {reference(referenceData[3], 4)} including children of all ages,
          women, transgenders, elderly persons, persons with specific health
          conditions, etc.{" "}
        </>
      ),
      img: (
        <div style={{ padding: "12px 0px" }}>
          <ImageWithCaption
            imageSrc={[DesignImg8]}
            captionText={
              <>
                <b>For example, </b>accessible gender-neutral washrooms, family
                washrooms and child-friendly facilities may be provided within
                all  Court Complexes, such as the accessible unisex toilets
                provided in Meghalaya High Court.
              </>
            }
            caption="Image 5: Accessible unisex toilets at the High Court of Meghalaya"
            creditLabel="Image Credit"
            creditValue=" Brinda Sastry"
            isZoom={true}
            // zoomImgStyle={{ height: "500px" }}
            imageDescription={ImageDesc5}
          />
        </div>
      ),
    },
    {
      content:
        "Conducting training and capacity-building sessions to sensitise the Court staff on the difficulties faced by diverse users and the facilities or measures that promote access to all, regardless of age, size, gender, ability, or disability.",
    },
    {
      content:
        "Designing the public interface of the Court Complex building to be aesthetically pleasing and friendly to a diverse set of users. This involves ensuring that the building image/architecture is not dominating and intimidating, and that the entrance is designed to be accessible, transparent and welcoming to the public. The design should move away from imposing colonial-era architecture and aim to use iconography to convey the idea of justice to the common person.",
    },
    {
      content:
        "Adopting artwork, iconography and other design features related to the local history and cultural traditions and encouraging people’s associations with the same. ",
      img: (
        <div style={{ padding: "12px 0px" }}>
          <ImageWithCaption
            imageSrc={[DesignImg9, DesignImg10]}
            captionText={
              <>
                <b>For example, </b>a signage system that uses colourful
                characters or traditional local art/ icons to create a calm and
                friendly experience may be provided as in the case of the
                Warangal POCSO and Family Court. Here the wayfinding signage is
                inspired by the traditional storytelling Cheriyal art form, and
                has doll characters that guide people through the Court Complex,
                instilling a sense of safety in the minds of the users and
                facilitating the right to feel protected.
                {reference(referenceData[4], 5)}
              </>
            }
            caption="Image 6: Culturally relevant signage and iconography at Warangal District Court, Telangana"
            creditLabel="Source"
            creditValue="Warangal District Court Design"
            isZoom={true}
            // zoomImgStyle={{ height: "450px" }}
            imageDescription={ImageDesc6}
          />
        </div>
      ),
    },
    {
      content:
        "Designing Court buildings that promote social integration among the users by involving the local community in the building construction or design of its spaces. ",
      img: (
        <div style={{ paddingBottom: "10px" }}>
          <ImageWithCaption
            imageSrc={[DesignImg11]}
            captionText={
              <>
                <b>For example, </b>engaging the local community in co-producing
                the artworks in the public areas, acknowledges the local
                cultural values and promotes social integration, as seen in the
                initiative undertaken in the Warangal District Court design.
                {reference(referenceData[5], 6)}
              </>
            }
            caption="Image 7: Involvement of local communities in public design elements at Warangal District Court, Telangana"
            creditLabel="Source"
            creditValue="Warangal Transformation Report"
            isZoom={true}
            zoomImgStyle={{ height: "500px" }}
            imageDescription={ImageDesc7}
          />
        </div>
      ),
    },
  ];
  const guideLine4Array = [
    {
      content:
        "Providing accessible signage and facilities to facilitate intuitive egress during emergencies. It includes provision of signs for safe evacuation routes to accessible assembly areas, alarms / warning systems with visual alerts, and access to ambulance services and medical facilities. ",
      img: (
        <div style={{ paddingBottom: "10px" }}>
          <ImageWithCaption
            imageSrc={[DesignImg12]}
            captionText={
              <>
                <b>For example, </b>a floor plan provided on all floors of the
                building to indicate the location of the user helps direct them
                to the closest exit. In addition, a digital screen with audio
                and video alerts should be provided.
                {reference(referenceData[6], 7)}
              </>
            }
            caption="Image 8: Fire Evacuation Plan Sign"
            creditLabel="Source"
            creditValue="Riteforyouwellness"
            isZoom={true}
            zoomImgStyle={{ height: "250px" }}
            imageDescription={ImageDesc8}
          />
        </div>
      ),
    },
    {
      content:
        "Ensuring that the plans and procedures for emergency systems are streamlined to enhance overall preparedness and response efficiency. This involves regular testing and updating of protocols for emergency systems (like visual alerts, evacuation routes, and assembly areas) and implementing comprehensive maintenance schedules for accessibility features (ramps, lifts, Braille signage, etc.) to guarantee their optimal functionality and usability. ",
    },
    {
      content:
        "Providing regular training and awareness programs for staff to ensure they are well-versed with the operation and maintenance of emergency and accessibility features and can handle diverse situations effectively. ",
    },
  ];
  const adaptabilityArray = [
    <>
      The prospect of{" "}
      <span style={{ color: "#DC002D" }}>
        <i>expandability</i>
      </span>{" "}
      and
      <span style={{ color: "#DC002D" }}>
        {" "}
        <i>scalability </i>
      </span>{" "}
      in terms of facilitating additions to the building;
    </>,
    <>
      <span style={{ color: "#DC002D" }}>
        <i>Flexibility</i>
      </span>{" "}
      and{" "}
      <span style={{ color: "#DC002D" }}>
        <i>versatility </i>
      </span>{" "}
      in the spatial organisation of functions within the building; and
    </>,
    <>
      <span style={{ color: "#DC002D" }}>
        <i>Convertibility</i>
      </span>{" "}
      of spaces for new uses and{" "}
      <span style={{ color: "#DC002D" }}>
        <i>adjustability</i>
      </span>{" "}
      of space to accommodate multiple uses or varied tasks.
    </>,
  ];
  const adaptabilityGuideline1Array = [
    "Preparing a phasing plan for the construction of annexe buildings to accommodate additional Courtrooms, workspaces, and storage facilities that would be required with the increase in caseloads.",
    "Reserving space for additional facilities such as security staff quarters, parking facilities, bank, post office and other amenities, and judicial residential quarters, particularly if the Court Complex is located in a context where such services and facilities are not in proximity.",
    <>Planning future expansion at the site level in a feasible, optimal and cost-effective manner, without disrupting existing activities.
      <div style={{ padding: "30px 0px" }}>
        <ImageWithCaption
          imageSrc={[DesignImg14, DesignImg15]}
          captionText={
            <>
              <b>For example, </b>a phasing plan could be used as in the case of
              the Kitsap County Courthouse renovation in Washington State, USA,
              which accommodates additional Courtrooms, parking and other
              functions.{reference(referenceData[7], 8)}{" "}
            </>
          }
          caption="Image 9: Phasing Plan at Kitsap County Court, Washington State (US)"
          imgStyle={{ height: "290px", objectFit: "cover" }}
          creditLabel="Source"
          creditValue="Kitsap Sun"
          isZoom={true}
          // zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc9}
        />
      </div>
    </>,
  ];
  const adaptabilityGuideline2Array = [
    "Designing the building with a structural redundancy to accommodate additional floors or withstand earthquakes.",
    <>Using a modular building structure that accommodates modifications such as the addition of floors, mezzanines, or basements (where feasible), and allows division or joining of rooms to house future functions.
      <div style={{ padding: "20px 0px" }}>
        <ImageWithCaption
          imageSrc={[ID16]}
          captionText={
            <>
              <b>For example, </b>a grid frame construction with standardised
              floor-to-ceiling heights could be used to make it easy to
              partition a space or add new spaces when accommodating additional
              Courtrooms, offices, storage and other facilities, as seen in the
              Chikkamagaluru District Court, Karnataka.
              {reference(referenceData[8], 9)}
            </>
          }
          caption="Image 10: Grid-frame construction of Chikkamagaluru District Court, Karnataka"
          creditLabel="Source"
          creditValue="Karnataka Judiciary"
          isZoom={true}
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc10}
        />
      </div>
    </>,
  ];
  const adaptabilityGuideline3Array = [
    "Adopting an open-plan layout for administrative offices to ensure adaptability to changes, additions and retrofitting, without compromising on the safety, access and comfort of the users.",
    <>Ensuring that the Court spaces are flexible enough to accommodate new functions with the changing needs of its stakeholders and the judicial functions.
      <ImageWithCaption
        imageSrc={[ID17]}
        captionText={
          <>
            <b>For example, </b>the Judge’s Chamber in the Karkardooma Court
            Complex, Delhi, which was converted into a Deposition room while
            accommodating the VWDC.
          </>
        }
        caption="Image 11: Conversion of Judge’s Chamber into Deposition Room at Karkardooma District Court Complex, Delhi"
        creditLabel={"Source"}
        creditValue={
          " Creating the Vulnerable Witness Deposition Complex from Existing Facilities, High Court of Uttarakhand"
        }
        isZoom={true}
        zoomImgStyle={{ height: "500px" }}
        imageDescription={ImageDesc11}
      />
    </>,
  ];
  const adaptabilityGuideline4Array = [
    "Incorporating the necessary physical infrastructure to realise the technological advancements required for conducting Court functions.",
    <>
      Providing reconfigurable digital infrastructure in workspaces and
      Courtrooms to ensure flexibility to accommodate varied functions.
      <div style={{ padding: "20px 0px" }}>
        <ImageWithCaption
          imageSrc={[ID18]}
          captionText={
            <>
              <b>For example, </b>audio-video integration for virtual hearings
              is adopted in the courtroom of Nayagarh District Court, Odisha.
            </>
          }
          caption="Image 12: Audio-Visual facilities in the courtroom at Nayagarh District Court, Odisha"
          creditLabel="Image Credit"
          creditValue="Brinda Sastry"
          // zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc12}
        />
      </div>
    </>,
    <>
      Using modular furniture and storage units within spaces of the Court
      Complex to plan for new spatial configurations and additions with ease.
      <div style={{ padding: "15px 0px 0px 0px" }}>
        <ImageWithCaption
          imageSrc={[ID19]}
          captionText={
            <>
              <b>For example, </b>use of modular furniture as in the case of the
              e-Seva Kendra at the High Court of Karnataka makes it easy to
              adapt to new spatial configurations.
              {reference(referenceData[9], 10)}
            </>
          }
          caption="Image 13: Modular furniture at e-Seva Kendra, High Court of Karnataka"
          creditLabel="Source"
          creditValue="Karnataka Judiciary"
          isZoom={true}
          // zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc13}
        />
      </div>
    </>,
  ];
  const comfortGuideline1Array = [
    "Segregating vehicular circulation routes and pedestrian paths at the site level to avoid conflict.",
    <>
      Providing restricted zones, and segregated and secure paths at the site
      level to ensure safety and minimise conflicts between users. This includes
      planning segregated entrances and paths within the Court building for
      different users to avoid conflict.
      <p style={{ fontStyle: "italic" }}>
        <b>For example,</b> the path taken by the Vulnerable Witnesses must be
        segregated from the path of the Accused to avoid confrontation.
        Additionally, for POCSO and Family Courts, separate waiting areas with
        adequate security must be provided for Vulnerable Witnesses and
        children.
      </p>
    </>,
    "Designing the buildings and site topography to ensure that sight lines and visibility to and from entrances and security cabins are clear. It includes ensuring that no areas of possible concealment for persons or undesirable activities, that are a threat to security, are present.",
    <>
      Adopting territorial reinforcement approaches, including low walls,
      fences, signage, landscaping and other design features, to define levels
      of access to secured areas.
      <div style={{ paddingBottom: "10px" }}>
        <ImageWithCaption
          imageSrc={[UnitedState, ID22]}
          captionText={
            <>
              <b>For example, </b>the landscaped entry plaza of the United
              States Federal Courthouse, Seattle with its cascading steps, water
              bodies and planting articulates levels of access from the street
              to the Courthouse entrance lobby.
              {reference(referenceData[10], 11)}
            </>
          }
          caption="Image 14: Landscaped entry plaza at the United States Federal Courthouse, Seattle (US)"
          creditLabel="Source"
          creditValue="PWP Landscape Architecture"
          isZoom={true}
          imageDescription={ImageDesc14}
        />
      </div>
    </>,

    <>Implementing security systems at the building and site level using advanced technology and non-intimidating security features, including in existing Court Complexes where there may be space constraints or challenges to restrain public movement because of site conditions.
      <div style={{ paddingTop: "15px" }}>
        <ImageWithCaption
          imageSrc={[ID23]}
          captionText={
            <>
              <b>For example, </b>a welcoming lobby where security equipment
              is integrated with the entrance doorway and the double-height
              lobby creates a non-intimidating and user-friendly entry to the
              Court building.{reference(referenceData[11], 12)}
            </>
          }
          caption="Image 15: Example of a Welcoming Entrance Lobby"
          creditLabel="Source"
          creditValue="Keith Fentress"
          isZoom={true}
          zoomImgStyle={{ height: "380px" }}
          imageDescription={ImageDesc15}
        />
      </div>
    </>,
  ];
  const comfortGuideline2Array = [
    "Providing windows, courtyards, skylights, etc., in Court spaces to ensure access to daylight, which helps to maintain circadian rhythms of the users, and for bringing in natural ventilation.",
    "Designing the internal environment of spaces with consideration given to ambient qualities such as noise levels, temperature, colour schemes and texture of room interiors, to ensure a comfortable, non-stressful and calm environment for all users.",
    "Providing ergonomic furniture in all spaces, including the Courtroom, office spaces, and waiting areas, to ensure comfort.",
    <>Bringing nature or greenery indoors or using surface treatments and colours to create a comfortable, aesthetically pleasing and enhanced sensory experience. For instance, use of specific colours can help to reduce stimulation and introduce a calming effect on children in Court spaces. This includes designing spaces such as a crèche for POCSO Courts, which are places of high distress and intimidation, to instil a sense of safety and calmness.
      <ImageWithCaption
        imageSrc={[ID24]}
        captionText={
          <>
            <b>For example, </b>in the Delhi High Court’s extension, the use
            of indoor green walls creates a comfortable environment for
            litigants, lawyers and Judges.{reference(referenceData[12], 13)}
          </>
        }
        caption="Image 16: Use of green walls at the Extension Building, Delhi High Court"
        creditLabel="Source"
        creditValue="Architectural Digest India"
        isZoom={true}
        // zoomImgStyle={{ height: "500px" }}
        imageDescription={ImageDesc16}
      />
    </>,
  ];
  const comfortGuideline3Array = [
    <>
      Adopting smart systems to monitor and manage building services like
      heating, ventilation, and air conditioning (“HVAC”), plumbing, electrical,
      and other operations, ensuring a comfortable, functional, and safe work
      environment.
      <div style={{ padding: "20px 0px" }}>
        <ImageWithCaption
          imageSrc={[ID28]}
          captionText={
            <>
              <b>For example, </b>adoption of smart systems for building
              management and access control would promote functional efficiency,
              as in the case of the Dharwad District Court in Karnataka,
              {reference(referenceData[14], 15)} where a Building Management
              System with 2,500 points for monitoring and control, and an Access
              Control System with 52 door controllers have been installed.
            </>
          }
          caption="Image 21: Building Management System at Dharwad District Court, Karnataka"
          creditLabel="Source"
          creditValue="Messung Building Automation & Controls"
          isZoom={true}
          zoomImgStyle={{ height: "400px" }}
          imageDescription={ImageDesc21}
        />
      </div>
    </>,
    "Conducting periodic audits and upgrades/maintenance of all internal and external building systems to ensure efficiency in the long run.",
  ];
  const comfortGuideline4Array = [
    "Installing customised warning systems with provision of appropriate accessible (audio, visual and tactile) signage to aid safe evacuation of diverse user groups in times of emergency.",
    "Providing building floor plans in all workspaces and public areas, indicating the routes to the closest exits, the staircases and location of designated refuge areas or assembly points.",
    "Practising regular emergency drills to ensure all building occupants become familiar with the emergency evacuation procedures and protocols.",
    "Ensuring the building adheres to the Fire and Life Safety norms as per the National Building Code of India.",
    <>Establishing and implementing policies, plans and procedures for managing the safety and security systems, and conducting training and capacity-building programs  for sensitising security personnel to address the needs of the diverse user groups.
      <p style={{
        fontSize: "16px",
        fontStyle: "italic",
        paddingLeft: (!isXs && !isSm) && "20px",
        color: "rgb(85, 85, 85)",
        marginTop: "20px"
      }}>
        <b>For example, </b>the Orissa High Court has set up a Judicial
        Infrastructure Management Agency to manage and maintain the
        infrastructure and operations of the Court Complex, which will
        ensure safety and comfort for all users.
      </p>
      <ImageWithCaption
        imageSrc={[emergencyExit1, emergencyExit2]}
        captionText={
          <>
            <b>For example,</b> providing a dedicated evacuation chair at
            emergency exits for ensuring accessible evacuation.
          </>
        }
        caption="Image 18: Example of dedicated wheelchair chair provided at emergency exit"
        creditLabel="Image Credit"
        creditValue="Brinda Sastry"
        isZoom={true}
        zoomImgStyle={{ height: "300px" }}
        imageDescription={ImageDesc18}
      />
    </>,
  ];

  const efficiencyGuideline1Array = [
    "Organising functions at the site level to facilitate efficient circulation. This includes organising the parking and locating building entrances to enable movement of all users without conflict.",
    "Determining the number and size of Courtrooms and workspaces, and scaling the infrastructure needed for judicial, administrative and legal functions, based on the caseload of the Court and the number of persons using the space, to avoid overcrowding.",
    <>rranging functions within the Court buildings logically to ensure related functions are adjacent and circulation is clear, simple, and in accordance with the workflow.
      <ImageWithCaption
        imageSrc={[ID26]}
        captionText={
          <>
            <b>For example, </b>the e-Seva Kendra in a Court Complex must be
            at the entrance of the Complex to ensure that all visiting users
            may locate it easily, such as the E-Seva Kendra in the Bhadrak
            District Court. Similarly the pending branch in a Court Complex
            must be in close proximity or adjacent to a Courtroom to ensure
            easy movement of files.
          </>
        }
        caption="Image 19: e-Seva Kendra at the entrance to the Court Complex in Bhadrak District Court, Odisha"
        creditLabel="Image Credit"
        creditValue="Brinda Sastry"
        isZoom={true}
        zoomImgStyle={{ height: "500px" }}
        imageDescription={ImageDesc19}
      />
    </>,
  ];

  const efficiencyGuideline2Array = [
    <>
      Providing high-quality physical infrastructure that is responsive to the
      needs of varied users including Judges, lawyers, staff, Accused and
      litigants. This includes provision of furniture, digital systems, office
      accessories, wayfinding and information systems, and amenities.
      <div style={{ paddingBottom: "20px" }}>
        <ImageWithCaption
          imageSrc={[storageSystem2, storageSystem1]}
          captionText={
            <>
              <b>For example, </b>facilitating Information & Communication
              Technology (“ICT”) in the Court Complex to enable various ICT
              services to function as smoothly as physical Courts, and adopting
              modern file storage and retrieval facilities such as Mobile
              Compactor Storage Systems. For example, the Storage Systems used
              in the Bhadrak District Court.
            </>
          }
          height="400px"
          caption="Image 20: Compactor Storage Systems at Bhadrak District Court, Odisha"
          creditLabel="Image Credit"
          creditValue="Shreya Shetty"
          isZoom={true}
          zoomImgStyle={{ height: "400px" }}
          imageDescription={ImageDesc20}
        />
      </div>
    </>,
    "Ensuring  efficient access to facilities to promote a comfortable environment for all users.",
  ];
  const efficiencyGuideline3Array = [
    "Adopting smart systems to monitor and manage building services like heating, ventilation, and air conditioning (“HVAC”), plumbing, electrical, and other operations, ensuring a comfortable, functional, and safe work environment.",
    "Conducting periodic audits and upgrades/maintenance of all internal and external building systems to ensure efficiency in the long run.",
  ];
  const sustainabilityGuideline1Array = [
    "Ensuring that the site can be approached by different modes of transport including walking, bicycling, and public transport. ",
    "Achieving functional optimization of the site which involves retrofitting existing structures and considering access roads, parking, vehicle barriers, perimeter lighting and other site security measures.",
    <>
      Ensuring sustainable use of land to minimise ecological impact. This
      involves laying out buildings in response to the site physiography by
      maintaining the site contours and views; preserving existing natural
      features and habitats; conserving eco-sensitive zones; and preventing soil
      erosion when applicable.
      <div style={{ padding: "20px 0px" }}>
        <ImageWithCaption
          imageSrc={[ID30]}
          captionText={
            <>
              <b>For example, </b>the National Judicial Academy building in
              Bhopal is stepped along the slope of the site and care has been
              taken to keep the heights low to frame unobstructed views of the
              lake. The terraces created at various levels have greenery and
              this integrates the building with the natural surroundings.
              {reference(referenceData[16], 17)}
            </>
          }
          caption="Image 22: Sustainable design of National Judicial Academy Bhopal"
          creditLabel="Source"
          creditValue="ArchitectureLive!"
          isZoom={true}
          // zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc22}
        />
      </div>
    </>,
    "Adopting landscaping practices that promote biodiversity and ecosystem health. This includes using native flora for low-maintenance landscaping, and drought-resistant plants to reduce water needs.",
    <>Adopting sustainable water management strategies such as rainwater harvesting and waste water management systems. This includes provision of pervious pavers, water retention ponds, swales and rain gardens that promote groundwater recharge.
      <div style={{ padding: "15px 0px 10px 0px" }}>
        <ImageWithCaption
          imageSrc={[ID31]}
          captionText={
            <>
              <b>For example, </b>in the case of the Warangal District Court,
              the Courtyard area outside the Judges’ lounge is landscaped with
              impervious material.{reference(referenceData[17], 18)}
            </>
          }
          caption="Image 23: Courtyard at Warangal District Court, Telangana"
          creditLabel="Source"
          creditValue="Warangal District Court Design"
          isZoom={true}
          // zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc23}
        />
      </div>
    </>,
  ];
  const sustainabilityGuideline2Array = [
    "Adopting climate-responsive building design which involves using culturally relevant materials and local construction techniques responsive to the local climate and geography.",
    <>
      Ensuring the Court building has a distinct visual identity shaped by the
      local cultural context. This involves avoiding uniformity in building
      style and building floor plans across regions, and incorporating local
      materials and architectural elements in the building design.
      <div style={{ padding: "20px 0px" }}>
        <ImageWithCaption
          imageSrc={[ID32]}
          captionText={
            <>
              <b>For example, </b>the facade of the Delhi High Court extension
              has geometric patterns on some vertical stone panels similar to
              the older historic Court building, thereby associating with the
              monument's historic context.{reference(referenceData[18], 19)}
            </>
          }
          caption="Image 24: Facade at the Extension Building, Delhi High Court"
          creditLabel="Source"
          creditValue="Delhi High Court Extension Design"
          isZoom={true}
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc24}
        />
      </div>
    </>,
    <>
      Incorporating local art and iconography in the design of the building
      interiors.
      <div style={{ padding: "15px 0px 10px 0px" }}>
        <ImageWithCaption
          imageSrc={[ID33]}
          captionText={
            <>
              <b>For example, </b>the facade of the upper floors of the Krushi
              Bhawan in Odisha features a distinctive brick pattern using clay
              in three different colours, which is inspired by the Ikat patterns
              of Odisha handlooms.{reference(referenceData[19], 20)}
            </>
          }
          caption="Image 25: Facade at the Krushi Bhawan, Odisha"
          creditLabel="Source"
          creditValue="ArchDaily"
          isZoom={true}
          zoomImgStyle={{ height: "400px" }}
          imageDescription={ImageDesc25}
        />
      </div>
    </>,
  ];
  const sustainabilityGuideline3SubArray = [
    "Utilising locally sourced, durable, low maintenance construction and finishing materials;",
    "Implementing recycling and waste reduction practices;",
    "Using low-flow water fixtures to reduce water usage;",
    "Designing windows with low heat transmittance materials for hot dry climates; and",
    "Using low volatile organic compounds (“VOCs”) materials for furnishings and finishes.",
  ];

  const romanListItem = () => {
    return (
      <ol type="i">
        <li>
          Utilising locally sourced, durable, low maintenance construction and
          finishing materials;
        </li>
        <li>Implementing recycling and waste reduction practices;</li>
        <li>Using low-flow water fixtures to reduce water usage;</li>
        <li>
          Designing windows with low heat transmittance materials for hot dry
          climates; and
        </li>
        <li>
          Using low volatile organic compounds (“VOCs”) materials for
          furnishings and finishes.
        </li>
      </ol>
    );
  };

  const sustainabilityGuideline3Array = [
    {
      content: (
        <>
          Incorporating passive design strategies that use vernacular design
          elements such as verandas, Courtyards, semi-open spaces, facades with
          shading devices, etc. This includes designing openings for natural
          light and ventilation; and incorporating greenery in buildings to
          enhance the internal environment.{" "}
        </>
      ),
      img: (
        <div style={{ padding: "15px 0px" }}>
          <ImageWithCaption
            imageSrc={[ID34]}
            captionText={
              <>
                <b>For example, </b>in the National Judicial Academy at Bhopal,
                the pergola running along the periphery of the building and
                Courtyards shades large openings and regulates the micro-climate
                of the interiors.{reference(referenceData[20], 21)}
              </>
            }
            caption="Image 26: Sustainable design of National Judicial Academy, Bhopal"
            creditLabel="Source"
            creditValue="National Judicial Academy Design"
            isZoom={true}
            // zoomImgStyle={{ height: "500px" }}
            imageDescription={ImageDesc26}
          />
        </div>
      ),
    },
    {
      content: (
        <>
          Adopting green building practices for energy efficiency, low waste
          generation, conserving natural resources, reducing carbon footprint,
          and reducing construction and operating costs. This includes adopting
          the following measures to keep spaces environmentally friendly and
          reduce embodied carbon: {romanListItem()}
        </>
      ),
      img: (
        <div style={{ padding: "20px 0px" }}>
          <ImageWithCaption
            imageSrc={[ID35]}
            captionText={
              <>
                <b>For example, </b>the Indira Paryavaran Bhawan, the new office
                building for the Ministry of Environment and Forest (MoEF), uses
                70% less energy than a conventional building by adopting green
                building concepts.{reference(referenceData[21], 22)}
              </>
            }
            caption="Image 27: Use of green building concepts at Indira Paryavaran Bhawan Delhi"
            creditLabel="Source"
            creditValue="NZEB"
            isZoom={true}
            // zoomImgStyle={{ height: "500px" }}
            imageDescription={ImageDesc27}
          />
        </div>
      ),
    },
    {
      content: (
        <>
          Adopting renewable energy resources, including solar energy panels or
          hybrid solar and wind harnessing systems, and other non-fossil fuel
          sources of energy.{" "}
        </>
      ),
      img: (
        <div style={{ padding: "20px 0px" }}>
          <ImageWithCaption
            imageSrc={[ID36]}
            captionText={
              <>
                <b>For example, </b>the Khunti District Court (Jharkhand) (2015)
                was India’s first solar-powered Court Complex which generates
                180 KW of energy that is stored in batteries and used by the
                Court as well as other offices in the vicinity.
                {reference(referenceData[22], 23)}
              </>
            }
            caption="Image 28: Solar-powered Court Complex at Khunti District Court, Jharkhand"
            creditLabel="source"
            creditValue=" Planet Custodian"
            isZoom={true}
            // zoomImgStyle={{ height: "500px" }}
            imageDescription={ImageDesc28}
          />
        </div>
      ),
    },
    {
      content: (
        <>
          Implementing advanced building management systems that integrate
          technology and active systems. This includes use of smart building
          controls for optimising energy usage based on occupancy and usage
          patterns. For example, using occupancy sensors, dimmable energy
          efficient task lighting and individually controlled HVAC help to
          achieve an energy-conscious design.
        </>
      ),
    },
    {
      content: (
        <>
          Using concepts of adaptive re-use, retrofitting and renovation for
          existing Court buildings, and post-occupancy evaluation/audits for new
          buildings, to provide for a longer life cycle.
        </>
      ),
    },
    {
      content: (
        <>
          Implementing sustainable waste management practices for recycling of
          old records, disposal of sanitary/medical waste and garbage, and
          disposal/recycling of old or broken furniture and equipment.
        </>
      ),
    },
  ];

  const comfortDesignedArray = [
    {
      content: (
        <>
          Providing adequate numbers of common amenities and facilities such as
          waiting areas, washrooms, drinking water, food options, etc., on each
          floor of the Court building.
        </>
      ),
    },
    {
      content: (
        <>
          {" "}
          Ensuring that the common amenities are accessible and cater to the
          needs of diverse users such as children, elderly, mothers, and persons
          of different ethnic and religious backgrounds. This includes provision
          of a crèche, mother’s feeding room, family - friendly washrooms, multi
          - faith prayer rooms and other such facilities.
        </>
      ),
    },
    {
      content: (
        <>
          Ensuring that the common amenities are well-maintained, safe and
          comfortable. This includes the provision of dedicated,
          non-intimidating waiting areas for Vulnerable Witnesses or child
          victims. Provision of play equipment within the waiting areas for
          child victims/children accompanying litigants would help to make them
          feel at ease.{" "}
        </>
      ),
      img: (
        <div style={{ padding: "15px 0px" }}>
          <ImageWithCaption
            imageSrc={[hgIndia]}
            captionText={
              <>
                <b>For example, </b>providing accessible well-maintained, safe
                and comfortable seating in all waiting areas for the use of
                diverse user groups.{reference(referenceData[13], 14)}
              </>
            }
            caption="Image 17: Example of accessible, safe and comfortable seating"
            creditLabel="Image Credit"
            creditValue="Dr. Gaurav Raheja"
            isZoom={true}
            // zoomImgStyle={{ height: "500px" }}
            imageDescription={ImageDesc17}
          />
        </div>
      ),
    },
  ];

  const guidelineArray1 = [
    {
      content:
        "Providing accessible well-lit entrances (site and building), segregated paths, and designated parking, for diverse user groups. This includes provision of facilities for pedestrians, cyclists, persons with prams, persons using white cane, wheelchair users, etc. Additionally, vehicular parking designated for Persons with Disability should be in proximity to the building entrance.",
      para: (
        <div style={{ padding: "20px 0px" }}>
          <i>
            <b>For example,</b>{" "}
            <span style={{ color: "gray" }}>
              entrances designed with external ramps of appropriate slope,
              tactile paving, and handrails of appropriate height make them
              accessible. The external ramps should be provided with adequate
              shelter to ensure that they remain usable in all weather
              conditions.
            </span>
          </i>
        </div>
      ),
    },
    {
      content:
        "Providing accessible furniture, infrastructure, and assistive aids for the accessibility needs of all users in workspaces and Courtrooms. This includes providing infrastructure such as tinted glass, audio-video facility, secured lifts, etc., for the safety of Vulnerable Witnesses. Additionally, all users should be able to operate and use the spaces and facilities without difficulty.",
      img: (
        <div style={{ padding: "10px 0px" }}>
          <ImageWithCaption
            imageSrc={[DesignImg5]}
            captionText={
              <>
                <b>For example,</b> the elevated dais in every Courtroom may be
                accessible by having a ramp of appropriate ratio, along with a
                handrail. Alternatively, as in the case of the new extension
                building of the Delhi High Court, the Courtroom could be
                designed without any level differences.
                {reference(referenceData[1], 2)}
              </>
            }
            caption="Image 2: Courtroom without level differences in the new extension building of the Delhi High Court"
            creditLabel="Source"
            creditValue="Inhabitat"
            isZoom={true}
            // zoomImgStyle={{ height: "500px" }}
            imageDescription={ImageDesc2}
          />
        </div>
      ),
    },
    {
      content:
        "Providing accessible common amenities such as washrooms, sanitary provisions, canteens, crèche, waiting areas, e-Seva Kendras, ATMs, banks, etc. It includes provision of waiting areas with adequate seating options for wheelchair users, adequate tactile pavers in all corridors, liminal spaces and public spaces such as Courtyards with accessible movement space. This also involves adopting accessible heights, and assistive aids including tactile pavers, audio assistance, guard rails, beacon alarms, colour contrast, etc., that cater to diverse users' needs.",
      img: (
        <div style={{ paddingBottom: "10px" }}>
          <ImageWithCaption
            imageSrc={[DesignImg6]}
            captionText={
              <>
                <b>For example,</b> use of appropriate directional and warning
                tactile pavers with clear width for movement would make the
                corridors accessible as in the case of the corridors in the
                Meghalaya High Court.
              </>
            }
            caption="Image 3: Accessible corridor with clear width at the High Court of Meghalaya"
            creditLabel="Image Credit"
            creditValue="Brinda Sastry"
            // height={"600px"}
            isZoom={true}
            zoomImgStyle={{ height: "500px" }}
            imageDescription={ImageDesc3}
            className="image_responsive"
          />
        </div>
      ),
    },
    {
      content:
        "Ensuring that the designated accessible infrastructure created for specific needs is not repurposed for other functions, irrespective of their frequency of use, to ensure continuous accessibility for individuals with diverse needs.",
    },
  ];

  return (
    <div>
      <Typography>
        <h1 id="Principle" style={h1style}>
          PART B - PRINCIPLES-BASED DESIGN FRAMEWORK{" "}
        </h1>{" "}
        <h2 id="designPrinciple" style={h2style}>
          <span style={{ fontSize: "24px" }}>2. </span>
          DESIGN PRINCIPLES AND GUIDELINES
        </h2>
        <div
          style={{
            border: "1px solid black",
            padding: "7px",
          }}
        >
          <p
            style={{
              fontStyle: "italic",
              color: "#DC002D",
            }}
          >
            <b>Need for a principle-based approach</b>
          </p>
          <p style={{ ...paraStyle, fontStyle: "italic", color: "#DC002D" }}>
            In light of the needs identified when mapping each user’s journey, a
            new, more holistic approach to Court design is essential. This
            holistic approach should integrate core values as non-negotiable
            principles, ensuring that the Court Complex becomes genuinely
            user-centric as envisioned in the vision and goals of this Handbook.
          </p>
        </div>
        <CaptionWithBorders1
          image={[DesignImg1]}
          isZoom={true}
          caption={"Figure 12: Key to the Five Design Principles"}
          zoomImgStyle={{ height: "500px" }}
          className="image_responsive"
          imageDescription={FigureDesc12}
        />
        <p style={paraStyle}>
          This section defines{" "}
          <span style={{ color: "#DC002D" }}>
            five non-negotiable principles
          </span>
          , laid down in this Report, to guide the design of Court Complexes, to
          cater to the needs highlighted by the mapping of all user journeys and
          to formulate design considerations. These design principles are
          user-centric value statements that describe the most important goals
          that a Court Complex should deliver. Each principle has a set of
          guidelines and examples to aid its implementation.
        </p>
        <CaptionWithBorders1
          image={[DesignImg2]}
          isZoom={true}
          caption={
            "Figure 13: An illustrative representation of how to read the guidelines"
          }
          zoomImgStyle={{ height: "500px" }}
          imageDescription={FigureDesc13}
        />
        <h3 id="accessibility" style={h3style}>
          <span style={{ fontSize: "20px", color: "#073763" }}>
            {" "}
            2.1. Accessibility{" "}
          </span>
        </h3>
        <CaptionWithBorders1
          image={[DesignImg3]}
          isZoom={true}
          caption={
            "Figure 14: An overview of the design guidelines for the Accessibility Principle"
          }
          zoomImgStyle={{ height: "450px" }}
          imageDescription={FigureDesc14}
        />
        <p style={paraStyle}>
          The manner in which buildings are designed affects all users’ ability
          to move, see, hear and communicate effectively. A universal building
          design reflects the diversity of people who use it and does not impose
          barriers of any kind. Such a design approach makes the building
          accessible and inclusive, enabling diverse user groups including the
          elderly, children, and persons with visual impairment and cognitive
          impairment to participate equally, confidently, and independently in
          the functions it supports.
        </p>
        <p style={paraStyle}>
          As a public building, a Court building must be designed to be fair and
          non-discriminating to diverse user groups. It must be accessible to
          users of all genders, ages, ethnic backgrounds, socio-economic groups
          and those who may be Persons with Disabilities. An accessible Court
          Complex that adopts inclusive design principles enables people to use
          the spaces safely, with dignity, comfort, convenience and confidence.
          It also enhances the user experience and facilitates all users to be
          able to participate equally in judicial activities.
        </p>
        <CaptionWithBorders1
          image={[DesignImg4]}
          isZoom={true}
          caption={
            "Figure 15:  Universal Design India Principles: The Five Principles"
          }
          creditLabel={"Source"}
          imageCredit={
            "Developed based on the information from Harmonised Guidelines 2021, p. 24, Table 2.4: Universal Design India Principles"
          }
          zoomImgStyle={{ height: "500px" }}
          className="image_responsive"
          imageDescription={FigureDesc15}
        />

        <p style={paraStyle}>
          Additionally, a Court Complex must be designed to be accessible,
          effective, and intuitive in its spatial arrangement and image. The
          design must adhere to the five universal design principles of India
          which aim to make the Court Complex equitable and usable, and
          culturally, economically and aesthetically accessible.
          {reference(referenceData[0], 1)}
        </p>
        <h2 style={{ padding: "5px" }}>
          <i>
            GUIDELINE 1:
            <span
              style={{
                padding: "0px 5px",
                color: "#073763",
              }}
            >
              Provide Include And Accessible Facilities And Infrastructure
            </span>
          </i>
        </h2>
        <h3 style={{ lineHeight: "1" }}>
          <i>This may be accomplished by:</i>
        </h3>{" "}
        {generateCustomOrderedListObj(guidelineArray1, "a")}
        <h2>
          <i>
            GUIDELINE 2:
            <span
              style={{
                padding: "0px 5px",
                color: "#073763",
              }}
            >
              Provide Legible And Accessible Information And Wayfinding Systems
            </span>
          </i>
        </h2>
        <h3 style={{ lineHeight: "1" }}>
          <i>This may be accomplished by:</i>
        </h3>{" "}
        {generateCustomOrderedListObj(guideLine2Array, "a")}
        <h2 id="guideline3Heading">
          <i>
            GUIDELINE 3:
            <span
              style={{
                padding: "0px 5px",
                color: "#073763",
              }}
            >
              Ensure Accessible And Culturally Relevant Design For Diverse Users
            </span>
          </i>
        </h2>
        <h3 style={{ lineHeight: "1" }}>
          <i>This may be accomplished by:</i>
        </h3>
        {generateCustomOrderedListObj(guideLine3Array, "a")}
        <h2 id="guideline4Heading">
          <i>
            GUIDELINE 4:
            <span
              style={{
                padding: "0px 5px",
                color: "#073763",
              }}
            >
              Ensure Accessible Emergency Preparedness And Evacuation Systems
            </span>
          </i>
        </h2>
        <h3 style={{ lineHeight: "1" }}>
          <i>This may be accomplished by:</i>
        </h3>
        {generateCustomOrderedListObj(guideLine4Array, "a")}
        <DashedBorderStyle />
        <h3 id="adaptabilityHeading" style={h3style}>
          <span style={{ fontSize: "20px", color: "#FF0000" }}>
            2.2. Adaptability
          </span>
        </h3>
        <CaptionWithBorders1
          image={[DesignImg13]}
          isZoom={true}
          caption={
            "Figure 16: An overview of the design guidelines for the Adaptability Principle"
          }
          zoomImgStyle={{ height: "350px" }}
          imageDescription={FigureDesc16}
        />
        <p style={paraStyle}>
          Adaptability refers to the capacity or built-in ability of buildings
          to accommodate substantial changes. Changes may be expected in the
          internal configuration of spaces in the building, the external
          physical surroundings of the building, the financial outlay for
          designing and managing building infrastructure, and in the needs and
          expectations of the occupants. Typically building design is based on
          assumptions of future demands and performance; yet, in its life cycle,
          it undergoes many modifications. Buildings must be adaptable, both for
          day-to-day requirements and longer-term evolving demands of its
          context without substantial reconstruction and disruption of
          functions.{" "}
        </p>
        <p style={paraStyle}>Designing for adaptability involves ensuring:</p>
        {generateOrderedList(adaptabilityArray)}
        <p style={paraStyle}>
          Court buildings and infrastructure are usually designed for a lifespan
          of about 20-30 years. The planning and the design of a Court Complex
          must identify future growth and expansion areas for changing needs
          which may include modifications due to management reorganisation,
          personnel shifts, changes in operational methods, or the advent of
          technology-driven changes such as virtual hearings, e-filing or
          end-to-end digital Courts. The Court building design needs to be
          flexible to accommodate frequent renovation, retrofitting and
          alteration easily and economically.
        </p>
        <p style={paraStyle}>
          A robust infrastructure would ensure the accommodation of inevitable
          change without disrupting Court operations. With the advancement of
          technology and its integration into routine judicial processes, the
          physical environment should be geared towards adapting to future
          unforeseen uses. Additionally, the office/workspace infrastructure,
          interior systems, and furnishings must be adaptable in anticipation of
          such changes. Adaptability and flexibility in building and
          infrastructure design minimises risks, increases cost benefits and
          enhances the lifecycle of the building.{" "}
        </p>
        <h2 id="guideline1Heading">
          <i>
            GUIDELINE 1:
            <span
              style={{
                padding: "0px 5px",
                color: "#FF0000",
              }}
            >
              Anticipate and Plan for Future Growth of Court Functions
            </span>
          </i>
        </h2>
        <h3 style={{ lineHeight: "1" }}>
          <i>This may be accomplished by:</i>
        </h3>{" "}
        {generateCustomOrderedList(adaptabilityGuideline1Array, "a")}
        {/* <ImageWithCaption
          imageSrc={[DesignImg14, DesignImg15]}
          captionText={
            <>
              <b>For example, </b>a phasing plan could be used as in the case of
              the Kitsap County Courthouse renovation in Washington State, USA,
              which accommodates additional Courtrooms, parking and other
              functions.{reference(referenceData[7], 8)}{" "}
            </>
          }
          caption="Image 9: Phasing Plan at Kitsap County Court, Washington State (US)"
          imgStyle={{ height: "290px", objectFit: "cover" }}
          creditLabel="Source"
          creditValue="Kitsap Sun"
          isZoom={true}
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc9}
        /> */}
        <h2 id="guideline2Heading">
          <i>
            GUIDELINE 2:
            <span
              style={{
                padding: "0px 5px",
                color: "#FF0000",
              }}
            >
              Provide a Scalable and Flexible Building Structure
            </span>
          </i>
        </h2>
        <h3 style={{ lineHeight: "1" }}>
          <i>This may be accomplished by:</i>
        </h3>{" "}
        {generateCustomOrderedList(adaptabilityGuideline2Array, "a")}

        <h2 id="guideline3Heading">
          <i>
            GUIDELINE 3:
            <span
              style={{
                padding: "0px 5px",
                color: "#FF0000",
              }}
            >
              Design Adaptable and Convertible Workspaces
            </span>
          </i>
        </h2>
        <h3 style={{ lineHeight: "1" }}>
          <i>This may be accomplished by:</i>
        </h3>{" "}
        {generateCustomOrderedList(adaptabilityGuideline3Array, "a")}

        <h2 id="guideline4Heading">
          <i>
            GUIDELINE 4:
            <span
              style={{
                padding: "0px 5px",
                color: "#FF0000",
              }}
            >
              Provide Flexible Infrastructure to Accommodate Changes
            </span>
          </i>
        </h2>
        <h3 style={{ lineHeight: "1" }}>
          <i>This may be accomplished by:</i>
        </h3>{" "}
        {generateCustomOrderedList(adaptabilityGuideline4Array, "a")}
        <DashedBorderStyle />
        <h3 id="comfortAndSafetyHeading" style={h3style}>
          <span style={{ fontSize: "20px", color: "#7dc3a6" }}>
            2.3. Comfort and Safety
          </span>
        </h3>
        <CaptionWithBorders1
          image={[ID20]}
          isZoom={true}
          caption={
            "Figure 17: An overview of the design guidelines for the Comfort and Safety Principle"
          }
          zoomImgStyle={{ height: "350px" }}
          imageDescription={FigureDesc17}
        />
        <p style={paraStyle}>
          A public building with a quality workspace design leads to a less
          stressful and more productive atmosphere. All facilities provided in
          the building must cater to diverse user groups to make them feel
          comfortable and secure. The concept of comfort relates to the creation
          of spaces of physical and mental well-being through design.
        </p>
        <p style={paraStyle}>
          The judiciary, being a venue that addresses conflicts, should aim to
          provide an environment that is a safe space for all users. Creation of
          spaces for physical and mental well-being which consider ambient
          qualities including noise levels and temperature is essential. All
          people working in the Court Complexes, including the stakeholders who
          come to its doors to seek justice, must feel safe and comfortable in
          the physical space of the Court Complex and while experiencing the
          judicial processes.
        </p>
        <p style={paraStyle}>
          A key challenge for Court design is to mitigate, or at least not
          exacerbate, the feelings of anxiety, fear or intimidation that many
          feel when thrust into the Court system. Due consideration must be
          given to issues around dignity, legibility and equity in the design to
          ensure a comfortable and safe environment.
        </p>
        <h2 id="guideline1Heading">
          <i>
            GUIDELINE 1:
            <span
              style={{
                padding: "0px 5px",
                color: "#7dc3a6",
              }}
            >
              Adopt Design Strategies to Mitigate Security Risks for All People
              and Property
            </span>
          </i>
        </h2>
        <h3 style={{ lineHeight: "1" }}>
          <i>This may be accomplished by:</i>
        </h3>{" "}
        {generateCustomOrderedList(comfortGuideline1Array, "a")}

        <h2 id="guideline2Heading">
          <i>
            GUIDELINE 2:
            <span
              style={{
                padding: "0px 5px",
                color: "#7dc3a6",
              }}
            >
              Design the Internal Environment of Buildings for the Wellbeing of
              all Users
            </span>
          </i>
        </h2>
        <h3 style={{ lineHeight: "1" }}>
          <i>This may be accomplished by:</i>
        </h3>{" "}
        {generateCustomOrderedList(comfortGuideline2Array, "a")}

        <h2 id="guideline3Heading" style={{ paddingTop: "10px" }}>
          <i>
            GUIDELINE 3:
            <span
              style={{
                padding: "0px 5px",
                color: "#7dc3a6",
              }}
            >
              Provide Common Amenities Designed for the Comfort of all Users
            </span>
          </i>
        </h2>
        <h3 style={{ lineHeight: "1" }}>
          <i>This may be accomplished by:</i>
        </h3>{" "}
        {generateCustomOrderedListObj(comfortDesignedArray, "a")}
        <h2 id="guideline4Heading" style={{ paddingTop: "10px" }}>
          <i>
            GUIDELINE 4:
            <span
              style={{
                padding: "0px 5px",
                color: "#7dc3a6",
              }}
            >
              Provide Infrastructure and Systems for Safety in Case of
              Emergencies
            </span>
          </i>
        </h2>
        <h3 style={{ lineHeight: "1" }}>
          <i>This may be accomplished by:</i>
        </h3>{" "}
        {generateCustomOrderedList(comfortGuideline4Array, "a")}

        <DashedBorderStyle />
        <h3 id="efficiencyHeading" style={h3style}>
          <span style={{ fontSize: "20px", color: "#ed7d31" }}>
            2.4. Efficiency
          </span>{" "}
        </h3>
        <CaptionWithBorders1
          image={[ID25]}
          isZoom={true}
          caption={
            "Figure 18: An overview of the design guidelines for the Efficiency Principle"
          }
          zoomImgStyle={{
            height: "350px",
            objectFit: "contain",
            isResponsive: (isXs && isSm) && "0px"
          }}
          imageDescription={FigureDesc18}
        />
        <p style={paraStyle}>
          Buildings designed with adequate infrastructure and optimum working
          conditions make it convenient for its users and increase their
          efficiency. The judiciary must aim for an optimal operation of its
          various functions and processes. Workspaces with circulation that are
          simple, clear, precise, and follow the flow of the activities are most
          efficient. Efficiency is best achieved by providing services and
          facilities in a safe and secure environment that is built around the
          users’ needs.
        </p>
        <p style={paraStyle}>
          Well-designed infrastructure investments, coupled with a system for
          periodic audits and updates, will not only make the judicial work
          system efficient but also result in long-term economic benefits.
          Incorporating the principle of efficiency in design will enhance
          productivity and promote welfare of the Judicial Officers and staff
          working in the Court building.
        </p>
        <p style={paraStyle}>
          Court Complexes that adopt futuristic designs and systems are smarter
          and more efficient. By adopting advanced technology, the Court can
          optimise its performance, enhance productivity and promote users’
          welfare. In instances of retrofitting a space or re-using a building,
          ensuring a good fit between the spatial configuration and the proposed
          function will promote efficiency.
        </p>
        <h2 id="guideline1Heading">
          <i>
            GUIDELINE 1:
            <span
              style={{
                padding: "0px 5px",
                color: "#ed7d31",
              }}
            >
              Plan and Design Spaces for Optimal Use
            </span>
          </i>
        </h2>
        <h3 style={{ lineHeight: "1" }}>
          <i>This may be accomplished by:</i>
        </h3>{" "}
        {generateCustomOrderedList(efficiencyGuideline1Array, "a")}

        <h2 id="guideline2Heading" style={{ paddingTop: "10px" }}>
          <i>
            GUIDELINE 2:
            <span
              style={{
                padding: "0px 5px",
                color: "#ed7d31",
              }}
            >
              Provide Facilities that meet the Needs of all Users
            </span>
          </i>
        </h2>
        <h3 style={{ lineHeight: "1" }}>
          <i>This may be accomplished by:</i>
        </h3>{" "}
        {generateCustomOrderedList(efficiencyGuideline2Array, "a")}
        <h2 id="guideline3Heading" style={{ paddingTop: "12px" }}>
          <i>
            GUIDELINE 3:
            <span
              style={{
                padding: "0px 5px",
                color: "#ed7d31",
              }}
            >
              Adopt Efficient Building Operations And Management Systems
            </span>
          </i>
        </h2>
        <h3 style={{ lineHeight: "1" }}>
          <i>This may be accomplished by:</i>
        </h3>{" "}
        {generateCustomOrderedList(comfortGuideline3Array, "a")}
        <DashedBorderStyle />
        <h3 id="sustainabilityHeading" style={h3style}>
          <span style={{ fontSize: "20px", color: "#508b27" }}>
            2.5. Sustainability
          </span>
        </h3>
        <CaptionWithBorders1
          image={[ID29]}
          isZoom={true}
          caption={
            "Figure 19: An overview of the design guidelines for the Sustainability Principle"
          }
          zoomImgStyle={{ height: "300px" }}
          imageDescription={FigureDesc19}
        />
        <p style={paraStyle}>
          Sustainability concerns the environmental performance of building
          elements and strategies used in the planning and design of the
          building. Sustainable design is context-sensitive and
          resource-efficient. A resource-efficient and green building, which
          uses recycled and environmentally sustainable materials, sustains
          longer building life.
        </p>
        <p style={paraStyle}>
          A Court building that is sustainable should be energy-conscious and
          affordable to resource use. Innovative design approaches that
          integrate use of low-energy minimal carbon impact materials with
          adaptable and contextual design, will provide value for money and
          efficiency of operation.{" "}
        </p>
        <p style={paraStyle}>
          A Court Complex should be affordable to conduct daily business and
          maintenance and should have spaces and facilities designed for
          economic, social and environmental value. Such a Court Complex offers
          value for money and efficiency of operation. By adopting innovative
          sustainable design solutions the Court Complex can become economical
          to build and the operations and maintenance costs of utilities can be
          reduced to make it cost-effective in the long term. The energy
          consumption can be limited and carbon footprint can be reduced.
          {reference(referenceData[15], 16)}
        </p>
        <h2 id="guideline1Heading" style={{ paddingTop: "10px" }}>
          <i>
            GUIDELINE 1:
            <span
              style={{
                padding: "0px 5px",
                color: "#508b27",
              }}
            >
              Optimise Site Potential and Adopt Sustainable Site Planning
              Practices
            </span>
          </i>
        </h2>
        <h3 style={{ lineHeight: "1" }}>
          <i>This may be accomplished by:</i>
        </h3>{" "}
        {generateCustomOrderedList(sustainabilityGuideline1Array, "a")}

        <h2 id="guideline2Heading">
          <i>
            GUIDELINE 2:
            <span
              style={{
                padding: "0px 5px",
                color: "#508b27",
              }}
            >
              Practise a Context-Sensitive Approach to Building Design
            </span>
          </i>
        </h2>
        <h3 style={{ lineHeight: "1" }}>
          <i>This may be accomplished by:</i>
        </h3>{" "}
        {generateCustomOrderedList(sustainabilityGuideline2Array, "a")}
        <h2 id="guideline3Heading">
          <i>
            GUIDELINE 3:
            <span
              style={{
                padding: "0px 5px",
                color: "#508b27",
              }}
            >
              Optimise Carbon Reduction, Reduce Environmental Impact and
              Increase the Building Life Cycle
            </span>
          </i>
        </h2>
        <h3 style={{ lineHeight: "1" }}>
          <i>This may be accomplished by:</i>
        </h3>{" "}
        {generateCustomOrderedListObj(sustainabilityGuideline3Array, "a")}
        <p style={{ ...paraStyle, paddingTop: "10px" }}>
          For more examples of energy-efficient design in India, please refer to{" "}
          <span
            style={sectionStyle}
            onClick={() => goToSection("annexes", "HeadingAnnexure1")}
          >
            Annexure 1
          </span>
          .
        </p>
        <h2 ref={referencesRef} id="designRef" style={referenceStyle}>
          References
        </h2>
        <Divider />
        {referenceHtml(referenceData)}
      </Typography>
    </div>
  );
};

export default DesignPrincipals;
